module.exports = __webpack_public_path__ + "static/media/skhitom.6d7b5681.wav";